import React, { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "./components/Footer/Footer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ProductDetails from "./pages/ProductDetails";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import Wishlist from "./pages/Wishlist";
import Cart from "./pages/Cart";
import Shop from "./pages/Shop";
import SucessOrder from "./pages/SucessOrder";
import FAQ from "./pages/FAQ";
import Page404 from "./pages/404";
import ProtectedRoute from "./helpers/ProtectedRoute";
import Checkout from "./pages/Checkout";
import HotUpdate from "./components/HotUpdate/HotUpdate";
import { Toaster } from "react-hot-toast";
import ProductCategory from "./pages/ProductCategory";
import SmallHeader from "./components/Header/SmallHeader";
import Store from "./pages/Store";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Logout from "./pages/Logout";
import Search from "./pages/Search";
import WhatsappOverlay from "./components/Whatsapp/WhatsappOverlay";
import { baseURL } from "./helpers/Axios";
import Maintenace from "./pages/Maintenace";
import { HelmetProvider } from "react-helmet-async";
import OrderSuccess from "./pages/OrderSuccess";
import Cookies from "js-cookie";
import { v4 } from "uuid";
import Track from "./pages/Track";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ResetPasswordContainer from "./components/ResetPasswordContainer";
import Bundles from "./pages/Bundles";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import RedirectLogin from "./pages/RedirectLogin";

function App() {
  const [serverDown, setServerDown] = useState(false);

  // Check server status
  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        const response = await fetch(`${baseURL}/health-check`);
        if (!response.ok) throw new Error("Server is down");
        setServerDown(false); // Server is up
      } catch (error) {
        setServerDown(true); // Server is down
      }
    };

    // Check server status on mount
    checkServerStatus();
  }, []);

  // Set SessionID Cookie
  useEffect(() => {
    if (!localStorage.getItem("wishlists")) {
      localStorage.setItem("wishlists", "[]");
    }

    if (!Cookies.get("cartId")) {
      Cookies.set("cartId", v4());
    }
  }, []);

  // check server status;

  if (serverDown) {
    return <Maintenace />;
  }

  return (
    <HelmetProvider>
      <div className="w-full relative">
        {/* Whatsapp Overlay */}
        <WhatsappOverlay />
        <div className="w-full relative h-full">
          <HotUpdate />
          <SmallHeader />
          <Header />
          <div className="w-full h-full relative">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<Page404 />} />
              <Route path="/pages/faq" element={<FAQ />} />
              <Route path="/order-tracking" element={<Track />} />
              <Route
                path="/order-tracking/:id"
                element={<OrderTrackingPage />}
              />
              <Route path="/shop" element={<Shop />} />
              <Route path="/search" element={<Search />} />
              <Route path="/pages/privacy-policy" element={<Privacy />} />
              <Route path="/pages/term-condition" element={<Terms />} />
              <Route path="/pages/about-us" element={<About />} />
              <Route path="/pages/contact-us" element={<Contact />} />
              <Route path="/pages/our-store" element={<Store />} />
              <Route
                path="/product-category/:category"
                element={<ProductCategory />}
              />
              <Route path="/product/:slug" element={<ProductDetails />} />
              <Route path="/account/redirect" element={<RedirectLogin />} />
              <Route path="/account/login" element={<Login />} />
              <Route path="/account/logout" element={<Logout />} />
              <Route
                path="/account/recovery"
                element={<ResetPasswordContainer />}
              />
              <Route
                path="/account/reset/:id/:token"
                element={<ResetPassword />}
              />
              <Route path="/account/register" element={<Register />} />
              <Route path="/bundles" element={<Bundles />} />
              <Route
                path="/account/*"
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order-success"
                element={
                  <ProtectedRoute>
                    <SucessOrder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/success-order"
                element={
                  <ProtectedRoute>
                    <OrderSuccess />
                  </ProtectedRoute>
                }
              />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/cart" element={<Cart />} />
              <Route
                path="/checkout"
                element={
                  <ProtectedRoute>
                    <Checkout />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
          {/* Footer */}
          <Footer />
        </div>
        <Toaster position="bottom-center" containerClassName="capitalize" />
      </div>
    </HelmetProvider>
  );
}

export default App;
